import {
  DatePicker,
  DesktopDatePicker,
  DesktopTimePicker,
  MobileDatePicker,
  MobileDateTimePicker,
  DateTimePicker,
  DesktopDateTimePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import React, { useState } from "react";
import TimePickerCustom from "../../TimePickerCustom/TimePickerCustom";
import StaticTimePickerCustom from "../../TimePickerCustom/StaticTimePickerCustom";

export default function GeneralCustomDateTimePicker({
  TypeTimePicker = 1,
  label = "",
  valueStart,
  minutesStep=5,
  minutesStepEnabled=true,
  placeholder= "hh/mm",
  handleChange = () => null,
  handleBlur = null,
  showToolbar = false,
  minDate = null,
  maxDate = null,
  disabled = false,
}) {
  const [open, setOpen] = useState(false);
  const { component: Component, props: pickerProps } = resolvePickerConfig(TypeTimePicker, { minDate, maxDate, minutesStep, minutesStepEnabled });

  function close() {
    setOpen(false);
  }

  return (
    <Component
      {...pickerProps} 
      label={label}
      value={valueStart ? new Date(valueStart) : null}
      open={open}
      onOpen={() => { disabled ? setOpen(false) : setOpen(true) }}
      onClose={() => close()}
      onChange={disabled ? () => null : handleChange}
      cancelText={React.createElement("span", null, "indietro")}
      showToolbar={showToolbar}
      disabled={disabled}
      slotProps={{ textField: { variant: 'standard', fullWidth: true, ...(handleBlur && { onBlur: handleBlur }) } }}
      fullWidth
    />
  );
}

function resolvePickerConfig(type, { minDate, maxDate, minutesStep, minutesStepEnabled}) {
  switch (type) {
    // TIME PICKERS
    case 1:
      return {
        component: TimePickerCustom,
        props: {
          minTime: minDate,
          maxTime: maxDate,
          ...(minutesStepEnabled && { minutesStep }),
        }
      };

    case 2:
      return {
        component: MobileTimePicker,
        props: {
          minTime: minDate,
          maxTime: maxDate,
          ...(minutesStepEnabled && { minutesStep }),
        }
      };

    case 3:
      return {
        component: DesktopTimePicker,
        props: {
          minTime: minDate,
          maxTime: maxDate,
          ...(minutesStepEnabled && { minutesStep }),
        }
      };

    case 11:
      return {
        component: StaticTimePickerCustom,
        props: {
          minTime: minDate,
          maxTime: maxDate,
          ...(minutesStepEnabled && { minutesStep }),
        }
      };

    // DATE PICKERS
    case 4:
      return {
        component: DatePicker,
        props: { minDate, maxDate }
      };

    case 5:
      return {
        component: DesktopDatePicker,
        props: { minDate, maxDate }
      };

    case 6:
      return {
        component: MobileDatePicker,
        props: { minDate, maxDate }
      };

    // DATETIME PICKERS
    case 7:
      return {
        component: DateTimePicker,
        props: {
          minDateTime: minDate,
          maxDateTime: maxDate
        }
      };

    case 8:
    case 9:
      return {
        component: MobileDateTimePicker,
        props: {
          minDateTime: minDate,
          maxDateTime: maxDate
        }
      };

    case 10:
      return {
        component: DesktopDateTimePicker,
        props: {
          minDateTime: minDate,
          maxDateTime: maxDate
        }
      };

    default:
      console.error("Picker type not handled:", type);
      return {
        component: DatePicker,
        props: {}
      };
  }
}
